/**
 * WeedLifeCycles — мини-справочник «Жизненные циклы сорняков».
 * Тот же `ReferenceMiniCatalog`, что и у категорий болезней/вредителей.
 */
import { PlatformAdminLayout } from '@/layouts/PlatformAdminLayout';
import { ReferenceMiniCatalog } from '@/components/reference/ReferenceMiniCatalog';
import {
  useCreateWeedLifeCycle,
  useDeleteWeedLifeCycle,
  useUpdateWeedLifeCycle,
  useWeedLifeCycles,
} from './hooks/useCatalogQueries';
import { toast } from '@/lib/toast';

function plural(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m100 >= 11 && m100 <= 14) return 'сорняков';
  if (m10 === 1) return 'сорняк';
  if (m10 >= 2 && m10 <= 4) return 'сорняка';
  return 'сорняков';
}

export function PlatformAdminWeedLifeCyclesPage() {
  const q = useWeedLifeCycles();
  const createMut = useCreateWeedLifeCycle();
  const updateMut = useUpdateWeedLifeCycle();
  const deleteMut = useDeleteWeedLifeCycle();

  const items = q.data?.items ?? [];

  return (
    <PlatformAdminLayout>
      <ReferenceMiniCatalog
        title="Жизненные циклы сорняков"
        subtitle={`Мини-справочник · ${items.length} записей`}
        createLabel="Добавить цикл"
        usageBadgeUnit={plural}
        guardMessage="Используется сорняками — нельзя удалить"
        items={items}
        isLoading={q.isLoading}
        onCreate={async (payload) => {
          await createMut.mutateAsync(payload);
          toast.success('Жизненный цикл создан');
        }}
        onUpdate={async (id, payload) => {
          await updateMut.mutateAsync({ id, payload });
          toast.success('Жизненный цикл обновлён');
        }}
        onDelete={async (id) => {
          // Отказ ловит и показывает сам ReferenceMiniCatalog (AK-574).
          await deleteMut.mutateAsync(id);
          toast.success('Жизненный цикл удалён');
        }}
      />
      <p className="mt-3 text-[11px] text-muted-foreground">
        Изменения сразу доступны в select формы сорняка. Код — технический ключ
        (по нему работают фильтры и подбор препаратов), меняйте только название.
        EN-перевод отложен — ведём только RU.
      </p>
    </PlatformAdminLayout>
  );
}

export default PlatformAdminWeedLifeCyclesPage;
